'use strict';

module.exports = !('0' in [].concat(undefined).concat());


//////////////////
// WEBPACK FOOTER
// ./~/sugar/array/var/HAS_CONCAT_BUG.js
// module id = 468
// module chunks = 0